module.exports = __webpack_public_path__ + "static/carto-0632a356c681fb574e9db2bc19f09ede.webp";